
import { useNavigate } from 'react-router-dom';
import Navbar from '../../../components/feature/Navbar';
import Button from '../../../components/base/Button';
import JsonViewer from '../../../components/base/JsonViewer';

export default function PurchaseOrderTemplate() {
  const navigate = useNavigate();

  const purchaseOrderSchema = {
    "po_number": "",
    "po_date": "",
    "delivery_date": "",
    "buyer_name": "",
    "buyer_address": "",
    "buyer_contact": "",
    "supplier_name": "",
    "supplier_address": "",
    "supplier_contact": "",
    "shipping_address": "",
    "billing_address": "",
    "payment_terms": "",
    "delivery_terms": "",
    "total_amount": "",
    "currency": "",
    "tax_amount": "",
    "shipping_cost": "",
    "line_items": "",
    "item_code": "",
    "item_description": "",
    "quantity_ordered": "",
    "unit_price": "",
    "line_total": "",
    "unit_of_measure": "",
    "requested_delivery_date": "",
    "special_instructions": "",
    "approval_status": ""
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-cyan-50">
      <Navbar showUserActions={true} />
      
      <div className="px-4 py-6">
        <Button variant="outline" onClick={() => navigate('/templates')} className="mb-6">
          <i className="ri-arrow-left-line mr-2"></i>
          Back to Templates
        </Button>
      </div>
      
      <div className="flex flex-col items-center px-4">
        <div className="w-full max-w-4xl">
          <div className="text-center mb-8">
            <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-indigo-100">
              <i className="ri-shopping-cart-line text-2xl text-indigo-600"></i>
            </div>
            <h1 className="text-3xl font-bold text-gray-800 mb-2">Purchase Order Template</h1>
            <p className="text-lg text-gray-600">JSON Schema - View Only</p>
            <div className="w-full h-px bg-gray-300 mt-4"></div>
          </div>
          
          <div className="bg-white rounded-lg shadow-lg p-6">
            <div className="mb-4">
              <h2 className="text-xl font-semibold text-gray-800 mb-2">Schema Structure</h2>
              <p className="text-gray-600 text-sm mb-4">
                This template extracts purchase order information and line items from procurement documents.
              </p>
            </div>
            
            <JsonViewer data={purchaseOrderSchema} />
          </div>
        </div>
      </div>
    </div>
  );
}
